import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchUpdateSilverApiKeySettings(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingUpdateSilverAPIKeySettingsAttempt', handleUpdateSilverApiKeySettings, api);
}

function* handleUpdateSilverApiKeySettings(api: SettingGateway) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;

    if (!authToken && authToken === undefined) {
        yield put(combinedActions.settingUpdateSilverAPIKeySettingsFailure(ErrorMessages.GenericRequiredFieldNotProvided));
        return;
    }

    const response = yield* call([api, api.updateSilverApiKeySettings], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingUpdateSilverAPIKeySettingsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        toast.success('Silver API Key Generated Successfully!');
        yield put(combinedActions.settingSetRegenerateSilverAPIKeyModalIsOpen(false));
        yield put(combinedActions.settingUpdateSilverAPIKeySettingsSuccess());
        yield put(combinedActions.settingGetSilverAPIKeySettingsAttempt());
        yield put(combinedActions.settingGetSilverAPIKeyHistoryListingAttempt());
    }
}
